import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setIntervention } from "../../../actions";
import t from "../../translate";
import ContentEditable from 'react-contenteditable';

let saveSettingsTimeout = null;

const Intro = props => {
  const [intro, setIntro] = useState('');

  const dispatch = useDispatch();
  const intervention = useSelector(state => state.intervention);


  useEffect(() => {
    if(props.type == "lessons"){
      setIntro(typeof intervention.settings.lessonsIntro != 'undefined' ? intervention.settings.lessonsIntro:'')
    }
    if(props.type == "optional-lessons"){
      setIntro(typeof intervention.settings.optionalLessonsIntro != 'undefined' ? intervention.settings.optionalLessonsIntro:'')
    }
    if(props.type == "goals"){
      setIntro(typeof intervention.settings.goalsIntro != 'undefined' ? intervention.settings.goalsIntro:'')
    }
    if(props.type == "stress"){
      setIntro(typeof intervention.settings.stressIntro != 'undefined' ? intervention.settings.stressIntro:'')
    }
    if(props.type == "sleepdiary"){
      setIntro(typeof intervention.settings.sleepdiaryIntro != 'undefined' ? intervention.settings.sleepdiaryIntro:'')
    }
  }, [intervention]);

  const onChange = e => {
    setIntro(e.target.value)
    if(props.type == "lessons"){
      intervention.settings.lessonsIntro = e.target.value;
    }
    if(props.type == "goals"){
      intervention.settings.goalsIntro = e.target.value;
    }
    if(props.type == "optional-lessons"){
      intervention.settings.optionalLessonsIntro = e.target.value;
    }
    if(props.type == "stress"){
      intervention.settings.stressIntro = e.target.value;
    }
    if(props.type == "sleepdiary"){
      intervention.settings.sleepdiaryIntro = e.target.value;
    }

    props.setErrorMessage("");
    clearTimeout(saveSettingsTimeout);

    saveSettingsTimeout = setTimeout(() => {
      props.saveSettings(
        intervention.id,
        intervention.organisation_id,
        intervention.title,
        intervention.settings
      );
    }, 1500);
  };

  return (
    <div className="intro">
      <ContentEditable
          html={intro}
          placeholder={props.placeholder}
          disabled={false}
          onChange={onChange}
          className="introTextarea"
        />
    </div>
  );
};

export default Intro;
